export default __webpack_public_path__ + "static/media/Design_Graphic.d7d6d09b.jpg";